import React from 'react';
import { HealthOverviewPage } from '../components/FigmaHealthOverview';

const HealthOverviewDemo: React.FC = () => {
  // Mock data matching the Figma design
  const mockStats = [
    {
      label: 'Tổng đánh giá',
      value: 254,
      status: 'good' as const
    },
    {
      label: 'Tình Trạng Tốt',
      value: 174,
      status: 'good' as const
    },
    {
      label: 'Tình Trạng Khá',
      value: 22,
      status: 'fair' as const
    },
    {
      label: 'Cần Lưu Ý',
      value: 34,
      status: 'attention' as const
    },
    {
      label: 'Theo Dõi Sát',
      value: 24,
      status: 'monitor' as const
    }
  ];

  const mockRisks = [
    {
      label: '10-year CVD Risk',
      value: 0.8,
      status: 'low' as const,
      description: 'Nguy Cơ Thấp'
    },
    {
      label: 'ASCVD',
      value: 0.76,
      status: 'low' as const,
      description: 'Nguy Cơ Thấp'
    },
    {
      label: 'CVA',
      value: 0.45,
      status: 'low' as const,
      description: 'Nguy Cơ Thấp'
    },
    {
      label: 'CHF',
      value: 0.62,
      status: 'low' as const,
      description: 'Nguy Cơ Thấp'
    }
  ];

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '32px' }}>
      <div style={{ boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)' }}>
        <HealthOverviewPage
          patientName="Nguyễn Phi Lê"
          score={85}
          doctorNote="Sức Khỏe Tốt"
          stats={mockStats}
          risks={mockRisks}
        />
      </div>
    </div>
  );
};

export default HealthOverviewDemo;